<template>
  <BContainer
    v-if="user"
  >
    <BRow
      class=" mx-1"
    >

      <BCol
        cols="12"
        class="p-2 border-bottom mt-2"
      >
        <h5 class="text-center text-md-left font-weight-bold">
          Purchase Orders
        </h5>
      </BCol>

      <BCol
        cols="12"
        class="px-4"
      >
        <BRow>
          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow
              style="border-radius: 0; border-bottom: 1px solid #dadada;"
            >
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.scheduling', params: { scheduler: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="scheduling.pending"
                    title="Pending"
                    sub-title="Scheduling"
                    variant="dark"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>

              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.scheduling', params: { scheduler: 'histories' }}">
                  <Card
                    :loading="fetching"
                    :count="scheduling.scheduled"
                    :border-right="borderRight"
                    title="Scheduled"
                    sub-title="Scheduling"
                    variant="success"
                    icon="fad fa-file-check"
                  />
                </router-link>
              </BCol>

            </BRow>
          </BCol>

          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow
              style="border-radius: 0; border-bottom: 1px solid #dadada;"
            >
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.dispatching', params: { dispatcher: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="dispatching.pending"
                    title="Pending"
                    sub-title="Dispatching"
                    variant="dark"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>

              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.dispatching', params: { dispatcher: 'histories' }}">
                  <Card
                    :loading="fetching"
                    :count="dispatching.dispatched"
                    title="Dispatched"
                    sub-title="Dispatching"
                    variant="success"
                    icon="fad fa-file-check"
                  />
                </router-link>
              </BCol>

            </BRow>
          </BCol>

          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow>
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.receiving', params: { receiver: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="receiving.pending"
                    title="Pending"
                    sub-title="Receiving"
                    variant="dark"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>

              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.receiving', params: { receiver: 'histories' }}">
                  <Card
                    :loading="fetching"
                    :count="receiving.received"
                    :border-right="borderRight"
                    title="Received"
                    sub-title="Receiving"
                    variant="success"
                    icon="fad fa-file-check"
                  />
                </router-link>
              </BCol>

            </BRow>
          </BCol>

          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow>
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.closing', params: { closer: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="closing.pending"
                    title="Pending"
                    sub-title="Closing"
                    variant="dark"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>

              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.deliveries.closing', params: { closer: 'histories' }}">
                  <Card
                    :loading="fetching"
                    :count="closing.closed"
                    title="Closed"
                    sub-title="Closing"
                    variant="success"
                    icon="fad fa-file-check"
                  />
                </router-link>
              </BCol>

            </BRow>
          </BCol>

        </BRow>
      </BCol>
    </BRow>

    <BRow
      class="mx-1"
    >
      <BCol
        cols="12"
        class="p-2 border-bottom mt-2"
      >
        <h5 class="text-center text-md-left font-weight-bold">
          Authority to Withdraws
        </h5>
      </BCol>

      <BCol
        cols="12"
        class="px-4"
      >
        <BRow>
          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow
              style="border-radius: 0; border-bottom: 1px solid #dadada;"
            >
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.withdrawals', params: { withdrawer: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="withdrawals.pending"
                    title="Pending"
                    sub-title="Withdrawal"
                    variant="dark"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.withdrawals', params: { withdrawer: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="withdrawals.processing"
                    title="Processing"
                    sub-title="Withdrawal"
                    variant="warning"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>
            </BRow>
          </BCol>

          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow
              style="border-radius: 0; border-bottom: 1px solid #dadada;"
            >
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.withdrawals', params: { withdrawer: 'histories', status: 'closed' }}">
                  <Card
                    :loading="fetching"
                    :count="withdrawals.closed"
                    title="Closed"
                    sub-title="Withdrawal"
                    variant="success"
                    icon="fad fa-file-check"
                  />
                </router-link>
              </BCol>
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.withdrawals', params: { withdrawer: 'histories', status: 'disapproved' }}">
                  <Card
                    :loading="fetching"
                    :count="withdrawals.disapproved"
                    title="Disapproved"
                    sub-title="Withdrawal"
                    variant="danger"
                    icon="fad fa-file-times"
                  />
                </router-link>
              </BCol>
            </BRow>
          </BCol>

          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow>
              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.printing', params: { printer: 'pending' }}">
                  <Card
                    :loading="fetching"
                    :count="printing.pending"
                    title="Pending"
                    sub-title="Printing"
                    variant="dark"
                    icon="fad fa-file-lines"
                  />
                </router-link>
              </BCol>

              <BCol
                cols="12"
                md="6"
              />

            </BRow>
          </BCol>

          <BCol
            cols="12"
            md="6"
            class="px-1"
          >
            <BRow>

              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.printing', params: { printer: 'histories' }}">
                  <Card
                    :loading="fetching"
                    :count="printing.printed"
                    title="Printed"
                    sub-title="Printing"
                    variant="success"
                    icon="fad fa-file-check"
                  />
                </router-link>
              </BCol>

              <BCol
                cols="12"
                md="6"
              >
                <router-link :to="{ name: 'lo.atws.withdrawals', params: { withdrawer: 'histories', status: 'canceled' }}">
                  <Card
                    :loading="fetching"
                    :count="withdrawals.canceled"
                    title="Canceled"
                    sub-title="Withdrawal"
                    variant="danger"
                    icon="fad fa-file-times"
                  />
                </router-link>
              </BCol>
            </BRow>
          </BCol>
        </BRow>
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import Card from '@/components/custom/Card'

import { SLODashboard } from '@/services/lo'

export default {
  name: 'VLogisticsOfficerDashboard',

  middleware: ['auth', 'lo'],

  components: {
    Card
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      borderRight: !this.isMobile(),
      scheduling: {
        pending: 0,
        scheduled: 0
      },
      dispatching: {
        pending: 0,
        dispatched: 0
      },
      receiving: {
        pending: 0,
        received: 0
      },
      closing: {
        pending: 0,
        closed: 0
      },
      withdrawals: {
        pending: 0,
        processing: 0,
        closed: 0,
        disapproved: 0,
        canceled: 0
      },
      printing: {
        pending: 0,
        printed: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  mounted () {
    if (this.user) {
      this.getStatistics()
    }
  },

  methods: {
    async getStatistics () {
      this.fetching = true
      return SLODashboard.getStatistics().then(({ data }) => {
        this.dispatching = {
          pending: data?.approver_dispatching_pending || 0,
          dispatched: data?.approver_dispatching_processed || 0
        }

        this.scheduling = {
          pending: data?.approver_scheduling_pending || 0,
          scheduled: data?.approver_scheduling_processed || 0
        }

        this.receiving = {
          pending: data?.approver_delivery_pending || 0,
          received: data?.approver_delivery_processed || 0
        }

        this.closing = {
          pending: data?.approver_closing_pending || 0,
          closed: data?.approver_closing_processed || 0
        }

        this.withdrawals = {
          pending: data.stock_withdrawal_total_pending,
          processing: data.stock_withdrawal_total_processing,
          closed: data.stock_withdrawal_total_closed,
          disapproved: data.stock_withdrawal_total_disapproved,
          canceled: data.stock_withdrawal_total_canceled
        }

        this.printing = {
          pending: data?.stock_withdrawal_printing_total_pending || 0,
          printed: data?.stock_withdrawal_printing_total_processed || 0
        }
      }).catch(() => {
        this.dispatching = {
          pending: 0,
          dispatched: 0
        }

        this.scheduling = {
          pending: 0,
          scheduled: 0
        }

        this.closing = {
          pending: 0,
          closed: 0
        }

        this.withdrawals = {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        }

        this.printing = {
          pending: 0,
          printed: 0
        }
      }).finally(() => {
        this.fetching = false
      })
    }
  }
}
</script>
